import localforage from 'localforage';

export const applicationStorage = localforage.createInstance({
    name: 'application', 
    driver: localforage.INDEXEDDB, 
    storeName: 'application',
});

export const cacheStorage = localforage.createInstance({
    name: 'application', 
    driver: localforage.INDEXEDDB, 
    storeName: 'cache',
});

export const datasetgridColumnsStorage = localforage.createInstance({
    name: 'application', 
    driver: localforage.INDEXEDDB, 
    storeName: 'datasetgrid_columns',
});

export const datasetgridFiltersStorage = localforage.createInstance({
    name: 'application', 
    driver: localforage.INDEXEDDB, 
    storeName: 'datasetgrid_filters',
});

export const datasetgridSortsStorage = localforage.createInstance({
    name: 'application', 
    driver: localforage.INDEXEDDB, 
    storeName: 'datasetgrid_sorts',
});

export const setCacheItem = async (key, data, expiration = 0) => {
    let timestamp = Date.now();
    let validTo = timestamp + (1000 * 60 * expiration);
    return cacheStorage.setItem(key, { timestamp, validTo, expiration, data });
};

export const getCacheItem = async (key) => {
    const cacheData = await cacheStorage.getItem(key);

    let returnObject = {
        timestamp: null,
        validTo: null,
        expiration: null,
        data: null,        
        isExpired: false,
    }

    if (!cacheData) {
        return returnObject;
    }

    returnObject = cacheData;   

    if (returnObject.validTo < Date.now()) {        
        return returnObject.isExpired = true;
    }

    return returnObject;
};
